"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VbzListItem = void 0;
/* eslint-disable sonarjs/cognitive-complexity */
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const Popover_1 = require("../Popover");
const Switch_1 = require("../Switch");
const className_1 = require("../../utils/className");
const useResize_1 = require("../../hooks/useResize");
exports.VbzListItem = ({ id, idLabelPrimary, idLabelSecondary, idTypeIcon, idAuxiliarText, icon, type = 'basic', infoText = 'popover', buttonType = 'select', label, caption, item, resultText, dark = false, onClick = () => undefined, onSwitch = () => undefined, onKeyDown = () => undefined, switchId, bgEmpty = false, disabled, className, expansible = false, onExpanded = () => undefined, expandedTitleFirst, expandedDescriptionFirst, expandedTitleSecond, expandedDescriptionSecond, isOpenItem = false, }) => {
    const { width } = useResize_1.useWindowSize();
    const isDesktop = width > 992;
    const [showInfo, setShowInfo] = react_1.useState(false);
    const thisRef = react_1.useRef(null);
    const [isOpen, setIsOpen] = react_1.useState(false);
    const handleOnClickItem = (event) => {
        if (disabled)
            return;
        if (type === 'info') {
            setShowInfo((prevState) => !prevState);
        }
        if (buttonType !== 'remove') {
            onClick(event);
        }
    };
    const handleOnClickClose = (event) => {
        if (disabled)
            return;
        if (type === 'button' && buttonType === 'remove') {
            onClick(event);
        }
    };
    const handleKeyDown = (event) => {
        if (disabled)
            return;
        if (event.key === 'Enter') {
            if (!thisRef.current)
                return;
            thisRef.current.click();
        }
        if (onKeyDown)
            onKeyDown(event);
    };
    // const handleFocus = (event: React.MouseEvent) => {
    //   if (disabled) return;
    //   if (onFocus) onFocus(true);
    // };
    const expansibleMobile = expansible && !isDesktop;
    const expansibleDesktop = expansible && isDesktop;
    return (react_1.default.createElement(reactstrap_1.ListGroupItem, { id: id, className: className_1.mapToCssModules([dark ? 'dark' : '', className]), disabled: disabled },
        react_1.default.createElement("button", { type: "button", ref: thisRef, onClick: handleOnClickItem, onMouseEnter: () => isDesktop && onExpanded(true, item), onMouseLeave: () => isDesktop && onExpanded(false, item), onKeyDown: handleKeyDown, className: className_1.mapToCssModules([
                label || caption ? 'high' : '',
                label ? 'label' : '',
                caption ? 'caption' : '',
                type === 'button' && buttonType === 'remove' ? 'removable' : '',
                bgEmpty ? 'removable' : '',
            ]), tabIndex: type === 'switch' ? -1 : undefined, disabled: disabled },
            react_1.default.createElement("div", { className: "vbz-ignore-click", tabIndex: -1 },
                icon,
                label && !caption && react_1.default.createElement("label", null, label),
                react_1.default.createElement("div", { className: "vbz-list-main-content" },
                    react_1.default.createElement("p", { id: idLabelPrimary }, item),
                    caption && react_1.default.createElement("label", { id: idLabelSecondary }, caption)),
                type === 'info' && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("i", { id: idTypeIcon, className: "material-icons notranslate vbz-button-icon__info vbz-list-icon" }, "\uE88E"),
                    react_1.default.createElement(Popover_1.VbzPopover, { isVisible: showInfo, position: "left", content: infoText }))),
                type === 'error' && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("i", { id: idTypeIcon, className: "material-icons notranslate vbz-button-icon__error vbz-list-icon" }, "\uE8B2"))),
                type === 'button' && buttonType === 'remove' ? (react_1.default.createElement("i", { tabIndex: -1, className: "material-icons", onClick: handleOnClickClose }, "\uE5CD")) : (type === 'button' && (react_1.default.createElement("i", { tabIndex: -1, id: idTypeIcon, className: "material-icons notranslate vbz-list-icon" }, "\uE315"))),
                type === 'switch' && (react_1.default.createElement(Switch_1.VbzSwitch, { id: `${switchId || 'switch'}`, onClick: onSwitch, dark: dark })),
                expansible ? (react_1.default.createElement("i", { onClick: (event) => {
                        event.stopPropagation();
                        if (!isDesktop) {
                            if (isOpen) {
                                onExpanded(false, item);
                                setIsOpen(() => false);
                            }
                            else {
                                onExpanded(true, item);
                                setIsOpen(() => true);
                            }
                        }
                    }, className: `material-icons-outlined ${expansibleDesktop ? '' : 'rotate-icon'} ${isOpenItem ? 'active' : ''}` }, isDesktop ? 'chevron_right' : 'expand_more')) : (react_1.default.createElement("div", { className: "vbz-list-text" },
                    react_1.default.createElement("p", { id: idAuxiliarText }, resultText))))),
        expansibleMobile && (react_1.default.createElement("div", { className: `dropdown-search-content-mobile ${isOpenItem ? 'active' : ''}` },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "title" }, expandedTitleFirst),
                react_1.default.createElement("p", { className: "description" }, expandedDescriptionFirst),
                react_1.default.createElement("p", { className: "title" }, expandedTitleSecond),
                react_1.default.createElement("p", { className: "description" }, expandedDescriptionSecond))))));
};
//# sourceMappingURL=index.js.map